import { Injectable } from '@angular/core';
import { scheduleChange, getClosingMinutes } from '@app/utils';
import {  ValueClockModel } from '@models/index';
import { FlightSummary } from '@models/micro';
import moment from 'moment';
import {BehaviorSubject, Observable, timer} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClockService {
  clock: Observable <Date>;
  infofecha$ = new BehaviorSubject<ValueClockModel>(new ValueClockModel());
  vr: ValueClockModel = new  ValueClockModel();
  hours = 0;
  minute = '';
  weekday = '';
  months = '';


  constructor() {
    this.clock = timer(0, 1500).pipe(map(() => new Date()), shareReplay(1));

  }
  getInfoReloj(): Observable<ValueClockModel>{
    this.clock.subscribe( t => {

      this.hours = t.getHours() % 12;
      this.hours = this.hours ? this.hours : 12;
      this.vr = {
        hora: t.getHours(),
        minutos: (t.getMinutes() < 10) ? '0' + t.getMinutes() : t.getMinutes().toString(),
        ampm: t.getHours() > 11 ? 'PM' : 'AM',
        diaymes: t.toLocaleString('es-MX', { day: '2-digit', month: 'long' }).replace('.', '').replace('-', ' '),
        diadesemana: t.toLocaleString('es-MX', { weekday: 'long' }).replace('.', ''),
        segundo: t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds().toString()

      };
      this.infofecha$.next(this.vr);
    });
    return this.infofecha$.asObservable();

  }

  startCountDown(flightSumary: FlightSummary, location:string){
    const {departureDateTime, isDomestic} = flightSumary;
    const period = 15 * 1000;
    let countdown = timer(0, period)
    .pipe(
      map(() => {
        const checkInHours = 4;
        const documentationMinutes = getClosingMinutes(isDomestic);
        const departureDate = moment(departureDateTime);
        const dateInit = departureDate.clone().subtract(checkInHours, 'hours');
        const dateInitValue = dateInit.toDate();
        const res = moment(dateInitValue).diff(new Date(),'minutes')
        let h = Math.floor(res / 60);
        h = h < 0 ? 0 : h;
        let m = res % 60;
        m = m < 0 ? 0 : m;
        const valid = scheduleChange(flightSumary,location)
        return {
          h,m,valid
        }
      },
      shareReplay(1)
      )
    )

    return countdown;
  }
}
